import chroma from "chroma-js";
import globals from "../partials/global-variables";
import stylesConfig from "../styles.config";
import infoTextTrigger from "../partials/info-text-trigger";

const imageQuestionHeadingFontColor = stylesConfig.colors.secondaryFontColor;
const questionHeadingFontSize = {
  $lg: stylesConfig.typography.fontSize(2.25),
  $xs: stylesConfig.typography.fontSize(1.375),
};
const questionHeadingFontColor = `${chroma(globals.colors.contrastDark).alpha(0.9)}`;
const infoTextBackground = globals.colors.transparent;
const infoTextTriggerFontColor = `${chroma(globals.colors.contrastDark).alpha(0.6)}`;
const imageQuestionInfoTextTriggerFontColor = `${chroma(globals.colors.white).alpha(0.9)}`;
const questionInfoTextFontSize = stylesConfig.typography.fontSize(0.875);

export default {
  container: {
    "& > p": {
      color: questionHeadingFontColor,
      textAlign: "center",
      width: "100%",
      fontWeight: 400,
      fontSize: questionHeadingFontSize.$lg,
      letterSpacing: ".75px",
      margin: 0,
      lineHeight: "1.2em",
      paddingBottom: "15px",
      "& .question-info-text": {
        position: "relative",
        width: "100%",
        display: "block",
        marginBottom: "0",
        marginTop: "10px",
        padding: "0 10px",
        background: infoTextBackground,
        lineHeight: "1.2em",
        letterSpacing: ".25px",
        fontWeight: 400,
        fontSize: "14px",
        color: infoTextTriggerFontColor,
        textAlign: "center",
        [`@media (${globals.breakpoints.$xs})`]: {
          marginTop: "5px",
        },
      },
      [`@media (${globals.breakpoints.$xs})`]: {
        fontSize: questionHeadingFontSize.$xs,
        letterSpacing: ".46px",
        lineHeight: "1.1em",
      },
    },
    ...infoTextTrigger,
    "& .question-type-hint": {
      display: "block",
      textAlign: "center",
      fontSize: stylesConfig.typography.fontSize(0.875),
      color: `${chroma(globals.colors.contrastDark).alpha(0.9)}`,
      fontWeight: 400,
      letterSpacing: ".25px",
      paddingBottom: "10px",
      [`@media (${globals.breakpoints.$xs})`]: {
        fontSize: stylesConfig.typography.fontSize(0.75),
        letterSpacing: ".21px",
        lineHeight: "1em",
      },
    },
    "& span.question-info-text": {
      fontSize: "14px",
      display: "block",
      lineHeight: 1.2,
    },
    "& .question-image": {
      position: "relative",
      width: "100%",
      minHeight: "300px",
      overflow: "hidden",
      height: "auto",
      display: "flex",
      alignItems: "center",
      marginBottom: "20px",
      [`@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)`]: {
        overflow: "hidden",
      },
      "&::after": {
        content: "''",
        display: "block",
        position: "absolute",
        zIndex: 1,
        left: 0,
        top: 0,
        width: "100%",
        height: "100%",
        background: "linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0.2) 70%,rgba(0,0,0,0.8) 100%)",
      },
      "& .image-element": {
        position: "absolute",
        width: "100%",
        height: "100%",
        backgroundSize: "cover",
        backgroundPosition: "center",
        top: 0,
      },
      "& p": {
        color: imageQuestionHeadingFontColor,
        position: "relative",
        textAlign: "center",
        width: "100%",
        top: 0,
        padding: "10px",
        zIndex: 2,
        margin: "auto",
        fontSize: stylesConfig.typography.fontSize(2.5),
        [`@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)`]: {
          left: "auto",
          display: "table-cell",
          verticalAlign: "middle",
          minHeight: "300px",
          width: "50%",
        },
        [`@supports (-ms-ime-align:auto)`]: {
          transform: "none",
          left: "auto",
        },
        "& span.question-info-text": {
          position: "relative",
          width: "100%",
          display: "block",
          marginBottom: "10px",
          marginTop: "10px",
          padding: "0 10px",
          background: infoTextBackground,
          lineHeight: "1.2em",
          letterSpacing: ".25px",
          fontWeight: 400,
          fontSize: questionInfoTextFontSize,
          color: imageQuestionInfoTextTriggerFontColor,
          pointerEvents: "none",
          textAlign: "center",
          [`@media (${globals.breakpoints.$xs})`]: {
            marginTop: "5px",
          },
        },
        [`@media (${globals.breakpoints.$xs})`]: {
          fontSize: stylesConfig.typography.fontSize(1.875),
          width: "100%",
        },
      },
    },
  },
};
